module.exports = __webpack_public_path__ + "img/qr1.db5117d3.jpeg";